import { components } from './components';

export const sharedEsUY = { components };
